import React, { createContext, useContext, useEffect, useState } from "react";
import SSE_CONFIG from "./Sse_config";

const SSEContext = createContext(null);

export function SSEProvider({ children }) {
  const [connected, setConnected] = useState(false);
  const [events, setEvents] = useState({});
  const API_URL = process.env.REACT_APP_SSE_PREFIX || "http://192.168.1.103:8000";

  useEffect(() => {
    console.log("Starting SSE connection...");

    const eventSource = new EventSource(
      `${API_URL}/sse_events_provider`
    );

    eventSource.onopen = () => {
      console.log("SSE connected");
      setConnected(true);
    };

    eventSource.addEventListener("cache_updated", (event) => {
      try {
        const data = JSON.parse(event.data);

        console.log("SSE event received:", data);

        const topic = data.topic;

        if (!topic) {
          console.warn("SSE event has no topic:", data);
          return;
        }

        setEvents((previous) => ({
          ...previous,
          [topic]: {
            ...data,
            receivedAt: Date.now(),
          },
        }));
      } catch (error) {
        console.error("Failed to parse SSE event:", error);
      }
    });

    eventSource.onerror = (error) => {
      console.error("SSE connection error:", error);
      setConnected(false);
    };

    return () => {
      console.log("Closing SSE connection...");
      eventSource.close();
    };
  }, []);

  const getComponentEvent = (componentName) => {
    const config = SSE_CONFIG[componentName];

    if (!config) {
      console.warn(`No SSE configuration found for ${componentName}`);

      return null;
    }

    const componentTopics = config.topics;

    const matchingEvents = componentTopics
      .map((topic) => events[topic])
      .filter(Boolean);

    if (matchingEvents.length === 0) {
      return null;
    }

    return matchingEvents.reduce((latest, current) => {
      if (!latest) return current;

      return current.receivedAt > latest.receivedAt ? current : latest;
    }, null);
  };

  const useSSEComponent = (componentName) => {
    const componentEvent = getComponentEvent(componentName);

    return {
      componentEvent,
    };
  };

  return (
    <SSEContext.Provider
      value={{
        connected,
        events,
        useSSEComponent,
      }}
    >
      {children}
    </SSEContext.Provider>
  );
}

export function useSSE(componentName) {
  const context = useContext(SSEContext);

  if (!context) {
    throw new Error("useSSE must be used inside SSEProvider");
  }

  if (!componentName) {
    return context;
  }

  return context.useSSEComponent(componentName);
}
